// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"toolbar_Toolbar__2eNcK","Logo":"toolbar_Logo__AAjRY","DesktopOnly":"toolbar_DesktopOnly__3OL7z"};